module.exports = __webpack_public_path__ + "static/media/logo-orange.d0571c05.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-orange.png
// module id = 434
// module chunks = 0